import axios		from 'axios'
import httpUtils	from '@core/assets/js/helpers/_partials/_http.utils'

/**
 *
 */
class Http
{
	/**
	 *
	 */
	constructor()
	{
		this.GET 	= 'GET'
		this.POST 	= 'POST'
		this.DELETE = 'DELETE'
		this.PUT 	= 'PUT'
		this.PATCH 	= 'PATCH'

		this.initialize();
		if(typeof window !== 'undefined')
		{
			if (!window.iProfesional)
				import('@core/assets/js/app/data')
					.then(data => {
						window.iProfesional = window.iProfesional || data.default
						window.iProfesional.progressbar.requestOpen = {}
					})
			this.window = window;
		}
		else
			this.window = false;
	}
	
	initialize()
	{
		this.defaults = {
			method: 'GET',
			baseUrl: '',
			url: '',
			data: false, // for POST PUT and PATCH
			params: false, // for query options
			query: {}, // for query options
			callback: response => {},
			onError: error => {},
			headers: {},
			progressbar: true,
			loading: false,
			datafull: false,
			withCredentials: true,
			modalError: true
		}
	}
	
	/**
	 *
	 * @param callback
	 * @constructor
	 */
	progressBar(callback)
	{
		import('@core/assets/js/modules/progress-bar').then((ProgressBar) => { callback(ProgressBar.default) })
	}
	
	/**
	 *
	 * @param options
	 * @constructor
	 */
	Request(options) {
		this.initialize();
		
		let settings = Object.assign({}, this.defaults, options);

		if (!settings.url)
			settings.url = ""
		
		if (undefined === settings.headers)
			settings.headers = null;
		
		if (this.window && 0 <= this.window.location.host.indexOf('backend'))
		{
			settings.query['no-cache'] = 'true';
		}
		
		let config = {
			method	: settings.method,
			url		: (settings.base || '') + settings.url,
			headers	: settings.headers
		}
		
		if ((undefined !== typeof settings.url) && (0 <= settings.url.indexOf('http') || 0 <= settings.url.indexOf('https'))) 
			config.url = settings.url
		
		if (false !== settings.params) {
			config.params = settings.params
		}
		
		if (false !== settings.query) {
			config.params = settings.query
		}
		
		if (false !== settings.data) {
			settings.data = httpUtils.queryStringToObject(settings.data)
			config.data = 'object' !== typeof settings.data ? JSON.parse(settings.data) : settings.data
			
			if ('multipart/form-data' !== config.headers['Content-Type'] &&
				// verificamos que no tenga sub-objetos
				false === Object.keys(config.data).map(key => {return typeof config.data[key]}).includes('object')
			) {
				config.data = new URLSearchParams(config.data).toString()
			}
		}
		
		try {
			if (this.window)
			{
				this.progressBar(ProgressBar => {
					ProgressBar.RequestStart(Object.assign(settings, config));
				})
			}
			
			return axios(config).then(response => {
				if (!this.ValidateResponse(response, settings))
					return false

				let dataResponse = response.data.data || response.data
				
				if (true === settings.datafull)
					dataResponse = response.data || response.data
				
				settings.callback(dataResponse)
				
				if (this.window)
				{
					this.progressBar(ProgressBar => {
						ProgressBar.RequestFinish(Object.assign(settings, config))
					})
				}
			}).catch(error => {
				settings.onError(error)

				if ('undefined' === typeof window)
					return;

				this.progressBar((ProgressBar) => {
					ProgressBar.RequestFinish(Object.assign(settings, config));
				})
				
				if (error.response && true === settings.modalError)
				{
					let message = error.response.status + '\n' +
						error.response.statusText + '\n' +
						(error.response.data.error || error.response.data)
					import('./modal').then(modal => {
						modal.default.Error(message)
					})
				} else {
					import('./modal').then(modal => {
						modal.default.Error(error.message)
					})
				}

				console.log('Error: ', error)
			})
		} catch (error) {
			this.progressBar((ProgressBar) => {
				ProgressBar.RequestFinish(Object.assign(settings, config));
			})
			import('./modal').then(modal => {
				modal.default.Error(error.message)
			})
			settings.onError(error)
		}
	}
	
	/**
	 *
	 * @param response
	 * @returns {boolean}
	 * @constructor
	 */
	ValidateResponse (response, settings = {})
	{
		if (200 !== response.status || false === response.data.success)
		{
			if(this.window)
			{
				this.progressBar((ProgressBar) => {
					ProgressBar.RequestFinish(settings);
				})
				
				if (true === settings.modalError)
					import('./modal').then(modal => {
						modal.default.Error(response.data.error)
					})
			}
			settings.onError(response.data.error)
			return false;
		}
		return true;
	}
	
	/**
	 * @param options
	 * @constructor
	 */
	Get(options) {
		var settings = Object.assign({}, this.defaults, options);
		settings.method = this.GET;
		
		this.Request(settings);
	}
	
	/**
	 *
	 * @param options
	 * @constructor
	 */
	Post(options) {
		var settings = Object.assign({}, this.defaults, options);
		settings.method = this.POST;
		
		this.Request(settings);
	}
	
	/**
	 *
	 * @param options
	 * @constructor
	 */
	Put(options) {
		var settings = Object.assign({}, this.defaults, options);
		settings.method = this.PUT;
		
		this.Request(settings);
	}
	
	/**
	 *
	 * @param options
	 * @constructor
	 */
	Delete(options) {
		var settings =Object.assign({}, this.defaults, options);
		settings.method = this.DELETE;
		
		this.Request(settings);
	}

  Patch(options) {
    var settings =Object.assign({}, this.defaults, options);
    settings.method = this.PATCH;

    this.Request(settings);
  }
}

const http = new Http()
export default http
